import React from "react";
import ReactDOM from "react-dom";
import { isReactComponent } from ".";
import {
  GrapesEditor,
  GrapesTypes,
  LoadComponentOptions,
} from "../../defenitions";
import DynamicLinkComponent from "../../../Base/DynamicLink";

type DynamicLinkProps = {
  href: string;
  text: string;
  openInNewTab: boolean | string;
};

export const DynamicLink = (props: DynamicLinkProps): JSX.Element => {
  const { href, text, openInNewTab } = props;
 
  return <DynamicLinkComponent href={href} text={text} openInNewTab={openInNewTab} />;
};

export default function (
  editor: GrapesEditor,
  options: LoadComponentOptions
): void {
  const domComponents = editor.DomComponents;
  const blockManager = editor.BlockManager;
  const defaultType = domComponents.getType("default");
  const { model, view } = defaultType;
  const compName = "DynamicLink";

  blockManager.add(GrapesTypes.DynamicLink, {
    label: "Dynamic Link",
    category: options.categoryLabel,
    attributes: { class: "fa fa-link" },
    textable: 1,
    content: `<span data-gjs-type="${GrapesTypes.DynamicLink}"></span>`,
  });

  const traits = [
    {
      label: "HREF",
      name: "href",
      changeProp: 1,
      placeholder: "https://example.com/{userId}",
    },
    {
      label: "Link Text",
      name: "text",
      changeProp: 1,
    },
    {
      label: "Open in New Tab",
      name: "openInNewTab",
      changeProp: 1,
      type: "checkbox",
    },
  ];

  domComponents.addType(GrapesTypes.DynamicLink, {
    isComponent(el: HTMLElement) {
      if (
        (el.getAttribute &&
          el.getAttribute("data-gjs-type") === GrapesTypes.DynamicLink) ||
        (el.attributes &&
          (el.attributes as any)["data-gjs-type"] === GrapesTypes.DynamicLink) ||
        isReactComponent(el, compName)
      ) {
        return {
          type: GrapesTypes.DynamicLink,
        };
      }
    },
    model: {
      defaults: {
        ...model.prototype.defaults,
        droppable: false,
        draggable: true,
        href: "https://example.com/{userId}",
        text: "Click here",
        openInNewTab: false,
        traits: [...model.prototype.defaults.traits, ...traits],
      },
    },
    view: view.extend({
      init() {
        traits.forEach((trait) => {
          this.listenTo(this.model, `change:${trait.name}`, this.handleChanges);
        });
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      handleChanges(e: any, value: any) {
        ReactDOM.unmountComponentAtNode(this.el);
        this.render();
      },
      onRender() {
        const { el } = this;
        const comps = this.model.get("components");
        const { href, text, openInNewTab } = this.model.attributes;
        comps.reset();

        // Escape single quotes in the attribute values to prevent breaking the component string
        const escapedHref = (href || '').replace(/'/g, "\\'");
        const escapedText = (text || '').replace(/'/g, "\\'");
        
        const compString = `<${compName} href='${escapedHref}' text='${escapedText}' openInNewTab='${openInNewTab}'></${compName}>`;
        comps.add(compString);

        ReactDOM.render(
          <DynamicLinkComponent 
            href={href} 
            text={text} 
            openInNewTab={openInNewTab}
          />, 
          el
        );
      },
    }),
  });
}
